exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style__LoginImage___1q3Qh {\n  height: 200px;\n  width: 200px; }\n\n.style__LoginLogo___BwxYA {\n  height: 29px;\n  width: 118px;\n  margin-top: 25px;\n  margin-bottom: 8px; }\n\n.style__LoginButton___2IT31 {\n  background-color: #4dc6e3;\n  color: white;\n  width: 200px;\n  margin-left: 0 !important; }\n\n.style__LoginRegister___3CAb7 {\n  margin-right: 20px;\n  margin-top: 20px; }\n\n.style__ForgotPassword_____WHa {\n  text-align: right;\n  color: #4dc6e3;\n  cursor: pointer;\n  width: 200px; }\n\n.style__errorMsg___c1NhR {\n  color: red;\n  font-size: 16px;\n  text-align: center; }\n\n.style__Epost___232xf {\n  width: 250px; }\n\n.style__Password___2vKWe {\n  width: 250px; }\n", ""]);

// exports
exports.locals = {
	"LoginImage": "style__LoginImage___1q3Qh",
	"LoginLogo": "style__LoginLogo___BwxYA",
	"LoginButton": "style__LoginButton___2IT31",
	"LoginRegister": "style__LoginRegister___3CAb7",
	"ForgotPassword": "style__ForgotPassword_____WHa",
	"errorMsg": "style__errorMsg___c1NhR",
	"Epost": "style__Epost___232xf",
	"Password": "style__Password___2vKWe"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/layout/Login/style.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/layout/Login/style.css
// module chunks = 0